// @ts-nocheck
import axios from 'axios';
import API_ENDPOINTS from '../../../const/ApiEndPoints';

export const getAllAttributeList = (params, loader = true) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.ATTR.GET_ALL_ATTRIBUTES}`,
      { params, loader }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export default function useAttributes() {
  const deleteAttribute = (attributeId) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.ATTR.GET_ALL_ATTRIBUTES}`,
        { params: { attribute_id: attributeId } }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const createAttribute = (payload) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.ATTR.GET_ALL_ATTRIBUTES}`,
        payload
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getSingleAttributeDetails = (attributeId) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.ATTR.GET_ALL_ATTRIBUTES}`,
        { params: { attribute_id: attributeId } }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const updateAttribute = (payload) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.ATTR.GET_ALL_ATTRIBUTES}`,
        payload
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const uploadHtmlAttributeTemplate = (payload) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.ATTR.HTML_ATTRIBUTE_UPLOAD_TEMPLATE}`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getSystemGeneratedAttribute = (entityType, entityId, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.ATTR.SYSTEM_GENERATED_ATTRIBUTES}`,
        {
          params: { entityType: entityType, entityId: entityId },
          loader: loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  return {
    getAllAttributeList,
    deleteAttribute,
    createAttribute,
    getSingleAttributeDetails,
    updateAttribute,
    uploadHtmlAttributeTemplate,
    getSystemGeneratedAttribute,
  };
}
